import { Injectable, WritableSignal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AttributeMenuService {
  shouldHilightRequired: WritableSignal<boolean> = signal(false);

  constructor() { }
}
